/** Плашка сообщает, что проект открыт в режиме просмотра (по общей ссылке или с телефона). */
import { UIKit } from "@/shared/ui";

export const ReadOnlyBanner = () => (
	<div className="pointer-events-none absolute bottom-2 left-1/2 z-40 max-w-viewport-gutter -translate-x-1/2 rounded-lg border border-warning-border bg-warning-soft/95 px-3 py-1.5 text-warning shadow-sm backdrop-blur-sm md:py-2">
		<UIKit.Text as="span" size="small" className="font-medium text-warning">
			Проект открыт в режиме просмотра
		</UIKit.Text>
	</div>
);
